export const API = {
  REFRESH_TOKEN: '/auth/refresh_token',
  PLANT_DATA: '/plantData',
  PLANT_MANAGEMENT: '/plantManagement',
  EMAIL: '/sendEmail',
  DEVICE_MANAGEMENT: '/deviceManagement',
  GET_TOKEN: '/auth/exchange_token',
  FEATURES: '/users/features',
  ADMIN_DASHBOARD: '/summaryBoard',
}
